import { render, staticRenderFns } from "./ManageCenterIndex.vue?vue&type=template&id=6c8e7cae"
import script from "./ManageCenterIndex.vue?vue&type=script&lang=js"
export * from "./ManageCenterIndex.vue?vue&type=script&lang=js"
import style0 from "./ManageCenterIndex.vue?vue&type=style&index=0&id=6c8e7cae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports